export default "__VITE_ASSET__CgtrGoaQ__"